import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function facebook(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54v-2.91h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.939"
        fill={checkColor(color)}
        fillRule="evenodd"
      />
    </svg>
  );
}

export function instagram(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M10.41 3c.403.002.906.007 1.565.019h3.68a6.569 6.569 0 012.226.464 4.59 4.59 0 012.626 2.626c.263.698.406 1.437.422 2.183 0 .182.001.34.005.495l.004.184c.015.584.043 1.221.043 3.001v.283c-.003 1.543-.028 2.154-.042 2.706l-.005.194c-.003.161-.005.327-.005.52a6.583 6.583 0 01-.465 2.224 4.586 4.586 0 01-2.626 2.626 6.566 6.566 0 01-2.183.422c-.18 0-.337.002-.49.005l-.184.005c-.583.015-1.226.043-3.006.043-2.436 0-2.742-.053-3.702-.053a6.558 6.558 0 01-2.225-.464 4.59 4.59 0 01-2.626-2.626A6.596 6.596 0 013 15.674V8.292a6.588 6.588 0 01.464-2.194A4.587 4.587 0 016.09 3.441a6.576 6.576 0 012.183-.422h.209c.433-.004.76-.015 1.326-.018zm5.193 1.622l-3.628.053H8.347a4.956 4.956 0 00-1.666.305c-.775.29-1.395.89-1.709 1.656a4.991 4.991 0 00-.306 1.666v7.256c.006.569.11 1.133.306 1.666a2.973 2.973 0 001.709 1.709c.533.197 1.097.3 1.666.306h7.256a4.987 4.987 0 001.666-.306 2.971 2.971 0 001.708-1.709c.197-.533.3-1.097.306-1.666V8.302a4.942 4.942 0 00-.306-1.666 2.97 2.97 0 00-1.708-1.708 4.962 4.962 0 00-1.666-.306zm-3.628 2.752a4.609 4.609 0 11-.002 9.218 4.609 4.609 0 01.002-9.218zm0 1.614a2.994 2.994 0 10-.001 5.989 2.994 2.994 0 00.001-5.989zM17.3 6.263a1.079 1.079 0 010 1.864 1.077 1.077 0 110-1.864z"
        fill={checkColor(color)}
      />
    </svg>
  );
}

export function pinterest(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M12.008 2C6.481 2 2 6.474 2 11.992c0 4.235 2.636 7.853 6.36 9.309-.091-.79-.166-2.007.032-2.87.181-.781 1.17-4.967 1.17-4.967s-.297-.6-.297-1.48c0-1.39.807-2.426 1.812-2.426.857 0 1.269.641 1.269 1.406 0 .855-.544 2.138-.832 3.33-.239.995.502 1.81 1.483 1.81 1.779 0 3.146-1.875 3.146-4.573 0-2.393-1.721-4.062-4.184-4.062-2.85 0-4.522 2.13-4.522 4.334 0 .855.329 1.776.74 2.278a.294.294 0 01.067.287c-.074.313-.247.995-.28 1.135-.041.181-.149.222-.338.132-1.252-.584-2.035-2.401-2.035-3.873 0-3.15 2.29-6.045 6.615-6.045 3.468 0 6.17 2.467 6.17 5.773 0 3.446-2.175 6.217-5.19 6.217-1.013 0-1.969-.526-2.29-1.151l-.626 2.377c-.222.871-.832 1.957-1.244 2.623.94.288 1.928.444 2.966.444C17.519 22 22 17.526 22 12.008 22.016 6.474 17.535 2 12.008 2z"
        fill={checkColor(color)}
      />
    </svg>
  );
}

export function twitter(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M21 6.665a7.396 7.396 0 01-2.12.578 3.691 3.691 0 001.62-1.992 7.421 7.421 0 01-2.35.896 3.711 3.711 0 00-4.43-.71 3.681 3.681 0 00-1.86 4.067 10.494 10.494 0 01-7.61-3.895 3.675 3.675 0 001.14 4.91 3.688 3.688 0 01-1.67-.458 3.688 3.688 0 003 3.606 3.71 3.71 0 01-1.72.11 3.699 3.699 0 003.45 2.55A7.428 7.428 0 013 17.85a10.539 10.539 0 0010.7.367 10.452 10.452 0 005.46-9.172v-.478A7.476 7.476 0 0021 6.665"
        fill={checkColor(color)}
      />
    </svg>
  );
}

export function youtube(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M20.6 7.7c-.2-.8-.8-1.4-1.6-1.6-2.3-.3-4.7-.4-7-.4s-4.7.1-7 .4c-.8.2-1.4.8-1.6 1.6C3.1 9.1 3 10.5 3 12c0 1.4.1 2.9.4 4.3.2.8.8 1.4 1.6 1.6 2.3.3 4.7.4 7 .4s4.7-.1 7-.4c.8-.2 1.4-.8 1.6-1.6.3-1.4.4-2.9.4-4.3 0-1.5-.1-2.9-.4-4.3zm-10.4 7V9.3l4.7 2.7-4.7 2.7z"
        fill={checkColor(color)}
      />
    </svg>
  );
}
